module.exports = __webpack_public_path__ + "img/hourglass.1a60cd12.svg";